import EmployerDashboardNav from "../../employer/EmployerDashboardNav";
import {PostedJobs} from "./ManageJobs";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../Breadcrumb";

const CandidateModal = ({ show, onHide, candidates, loading, error, selectedJob, handleCandidateClick }) => {

  useEffect(() => {
    return () => {
      candidates = null;
      selectedJob = null;
    }
  }, [candidates, selectedJob]);

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onHide}>
      <div className="modal-content-custom" onClick={e => e.stopPropagation()}>
        <div className="modal-header-custom">
          <h5 className="modal-title">
            {selectedJob && (
              <>
                Candidates for: {selectedJob.job_name}
                <span className="badge bg-light text-dark ms-2">
                  {candidates?.length || 0} Applicant{(candidates?.length !== 1) ? 's' : ''}
                </span>
              </>
            )}
          </h5>
          <button type="button" className="btn-close" onClick={onHide}></button>
        </div>

        <div className="modal-body-custom">
          {loading ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading candidates...</span>
              </div>
              <p className="mt-3">Loading candidates...</p>
            </div>
          ) : error ? (
            <div className="text-center text-danger p-4">
              <i className="fas fa-exclamation-triangle fa-3x mb-3"></i>
              <p>{error}</p>
            </div>
          ) : candidates?.length === 0 ? (
            <div className="text-center p-4">
              <i className="far fa-users-slash fa-3x mb-3"></i>
              <h5>No Candidates</h5>
              <p className="text-muted">No candidates have shortlisted for this job.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0 job-listing-table">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th className="text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                {candidates?.map((candidate) => (
                  <tr key={candidate.userid} className="candidate-row">
                    <td>
                      <div className="d-flex align-items-center">
                        <div>
                          <strong>{candidate.name}</strong>
                        </div>
                      </div>
                    </td>
                    <td>{candidate.email || 'N/A'}</td>
                    <td>{candidate.mobile || 'N/A'}</td>
                    <td>{candidate.status || 'N/A'}</td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-outline-primary mx-4"
                        onClick={() => handleCandidateClick(candidate)}
                      >
                        View Details
                        <i className="far fa-chevron-right ms-2"></i>
                      </button>
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ShortlistedCandidates = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const fetchCandidates = async (jobId) => {
    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      const applicationResponse = await axios.get(`${baseUrl}jobs/job/${jobId}/selected-candidates`);
      const applications = applicationResponse.data;

      const candidatePromises = applications.map(app =>
        axios.get(`${baseUrl}candidate_details/byuserid/${app.userid}`)
      );
      const candidateResponses = await Promise.all(candidatePromises);
      let newCandidates = [];
      const mergedCandidates = applications.map((app, index) => ({
        candidate: candidateResponses[index].data[0],
        application: app,
      }));
      mergedCandidates.forEach((object) => {
        newCandidates.push({...object.candidate, ...object.application})
      })
      setCandidates(newCandidates);
      setLoading(false);

    } catch (error) {
      setLoading(false);
    }
  };

  const handleJobClick = (job) => {
    setSelectedJob(job);
    fetchCandidates(job.job_id);
    setShowModal(true);
  };

  const handleCandidateClick = (candidate) => {
    setShowModal(false);
    navigate(`/candidate-review`, {state: {candidate, reviewMode: true, job: selectedJob, selected: candidate.status}});
  };

  return (
    <div className="manage-candidates-container">
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Manage Candidates</h2>
          <ul className="breadcrumb-menu">
            <li><a href="/">Home</a></li>
            <li className="active">Manage Candidates</li>
          </ul>
        </div>
      </div> */}
      <Breadcrumb
        title="Manage Candidates"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Manage Candidates", active: true }
        ]}
      />
      <div className="content-section py-5">
        <div className="container">
          <div className="row">
            <EmployerDashboardNav />
            <PostedJobs
              onJobClick={handleJobClick}
              actionFlag={false}
              selectedJobProp={selectedJob}
            />
          </div>
        </div>
      </div>

      <CandidateModal
        show={showModal}
        onHide={() => setShowModal(false)}
        candidates={candidates}
        loading={loading}
        selectedJob={selectedJob}
        handleCandidateClick={handleCandidateClick}
      />
    </div>
  );
}

export default ShortlistedCandidates;